export default __webpack_public_path__ + "static/media/58.5401323e.png";